<template>
  <page title="Campaigns">
    <div slot="page-header-right">
      <router-link to="campaigns/create">
        <button class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>
            <slot>Add Campaign</slot>
          </span>
        </button>
      </router-link>
    </div>

    <div class="box">
      <b-field>
        <b-input
          @blur="searchChanged()"
          :placeholder="$tc('dater.range')"
          type="search"
          v-model="query"
          icon="magnify"
          icon-clickable
          @input="(search) => campaigns.filter({ search }).load()"
          expanded
        ></b-input>
      </b-field>

      <hr/>

      <div class="card-content is-paddingless">
        <b-table
          :data="campaigns.data"
          :loading="campaigns.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="campaigns.current_page"
          :per-page="campaigns.per_page"
          :total="campaigns.total"
          @page-change="(page) => campaigns.changePage(page)"
          backend-sorting
          @sort="(field, direction) => campaigns.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Id" sortable width="80">{{
                props.row.id
              }}
            </b-table-column>

            <b-table-column field="cover" width="60">
              <img :src="props.row.cover_image_url" width="50"/>
            </b-table-column>

            <b-table-column field="title" label="Title" sortable>
              <router-link
                :to="`/campaigns/${props.row.id}/edit`"
                class="has-text-black mr-2"
              >{{ props.row.title }}
              </router-link
              >
            </b-table-column>

            <b-table-column
              field="price"
              width="180"
              label="Price"
              centered
              sortable
              class="has-text-grey"
            >
              <span class="has-text-black">{{ props.row.price }}₮</span> /
              <span class="line-through underline" style="text-decoration:line-through">{{ props.row.total_price }}₮</span>
            </b-table-column>

            <b-table-column
              field="start_date"
              width="180"
              label="Start date"
              centered
              sortable
              class="has-text-grey"
            >{{ props.row.start_date | date }}
            </b-table-column>

            <b-table-column
              field="end_date"
              width="180"
              label="End date"
              centered
              sortable
              class="has-text-grey"
            >{{ props.row.end_date | date }}
            </b-table-column>

            <b-table-column
              field="created_at"
              width="180"
              label="Created at"
              centered
              sortable
              class="has-text-grey"
            >{{ props.row.created_at | date }}
            </b-table-column>

            <b-table-column custom-key="actions" width="300">
              <div class="is-pulled-right">
                <router-link
                  class="button"
                  :to="`/campaigns/${props.row.id}/edit`"
                >Edit
                </router-link
                >
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      query: localStorage.getItem('campaign-search') || '',
      campaigns: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/campaigns"
      )
    };
  },

  created() {
    this.campaigns.filter({ search: this.query }).load();
  },

  methods: {
    searchChanged() {
      localStorage.setItem('campaign-search', this.query);
    }
  }
};
</script>
